var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      !_vm.only_submit
        ? _c(
            "b-col",
            { staticClass: "flex f-center" },
            [
              _c(
                "b-link",
                {
                  staticClass: "blinki-close-btn",
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.hide(_vm.modal_name)
                    },
                  },
                },
                [_vm._v("Annuler")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "f-center" },
        [
          _c(
            "b-button",
            {
              staticClass: "blinki-submit-btn",
              attrs: {
                disabled: _vm.formInvalid,
                type: "submit",
                variant: "primary",
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.showenTitle) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }